import { TimesheetApproveState } from './types'

export const state: TimesheetApproveState = {
  timeSheetsApprove: [],
  filters: {},
  totalRowFetchTimeSheet: 0,
  loading: false,
  totalHour: 0,
  sortParams: '',
}